<template>
  <consolidation-home />
</template>

<script>
import ConsolidationHome from "@/components/3pl/Operations/Consolidation/Home";

export default {
  components: {
    ConsolidationHome,
  },
};
</script>

<style></style>
